
import { authorizedRepresentativeTypes } from '@constants/ssap/hhmTypes/authorizedRepresentativeTypes.ts';
import { previousDataActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    applyingForFinancialAssistanceIndicator: false,
    authorizedRepresentative: {
        name: {
            firstName: null,
            middleName: null,
            lastName: null,
            suffix: null
        }
    },
    emergencyContactInfo: {
        name: {
            firstName: null,
            middleName: null,
            lastName: null,
            suffix: null
        }
    },
    getHelpIndicator: authorizedRepresentativeTypes.UNSPECIFIED,
    taxHousehold: {
        bloodRelationship: [],
        householdMember: []
    }
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case previousDataActionTypes.SET_PREVIOUS_DATA:
            return action.data;
        case previousDataActionTypes.UPDATE_PREVIOUS_DATA_SSNS:
            return {
                ...state,
                taxHousehold: {
                    ...state.taxHousehold,
                    householdMember: state.taxHousehold.householdMember.map(hhm => {
                        const {
                            applicantGuid
                        } = hhm;

                        const matchedSSN = action.ssns[applicantGuid];

                        if(!matchedSSN) {
                            console.error(`SSN for applicant with GUID ${applicantGuid} is not found amid received SSNs`);
                            return hhm;
                        } else {
                            return {
                                ...hhm,
                                socialSecurityCard: {
                                    ...hhm.socialSecurityCard,
                                    socialSecurityNumber: matchedSSN
                                }
                            };
                        }
                    })
                }
            };
        case previousDataActionTypes.UPDATE_PREVIOUS_DATA_IMI:
            return {
                ...state,
                taxHousehold: {
                    ...state.taxHousehold,
                    householdMember: state.taxHousehold.householdMember.map(hhm => {
                        const {
                            applicantGuid
                        } = hhm;

                        const matchedIMI = action.imi[applicantGuid];

                        if (!matchedIMI) {
                            console.error(`Immigration Data for applicant with GUID ${applicantGuid} is not found`);
                            return hhm;
                        } else {
                            return {
                                ...hhm,
                                citizenshipImmigrationStatus: {
                                    ...hhm.citizenshipImmigrationStatus,
                                    citizenshipDocument: {
                                        ...hhm.citizenshipImmigrationStatus.citizenshipDocument,
                                        ...matchedIMI
                                    }
                                }
                            };
                        }
                    })
                }
            };
        case previousDataActionTypes.CLEAR_PREVIOUS_DATA:
        case previousDataActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectIfPreviousDataLoaded = state => !!state.ssapApplicationId;
export const getPreviousApplicantGuids = state => state.taxHousehold.householdMember.map(hhm => hhm.applicantGuid);
export const getPreviousApplicationId = state => state.ssapApplicationId;